import { SvgIcon } from "@mui/material";

// Eye Icon
export function DownloadIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
        "& g": {
          stroke: (theme) => theme.palette.text.primary,
        },
      }}
      width="24px"
      height="24px"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.9994 14.7324V4.25M11.9994 14.7324L8.41309 10.8702M11.9994 14.7324L15.5855 10.8702"
        stroke={props.color || "#fff"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 15.2852V16.9406C4 18.7683 5.4823 20.2506 7.31 20.2506H16.6894C18.5171 20.2506 19.9994 18.7683 19.9994 16.9406V15.2852"
        stroke={props.color || "#fff"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
